const studioTexts = {
  fr: {
    title: "Le studio",
    switchLang: "Click here for the english version",
    paragraph: [
      `La caverne d’Ali Baba !
       Instruments, micros, amplis… et surtout, de bonnes vibrations !`,
      `Un studio lumineux, accueillant et adaptable, où tout peut arriver : une grande régie, une
       pièce cosy pour batterie, voix ou instruments… et toute la maison peut se transformer en
       cabines pour les amplis pendant que le groupe reste ensemble dans les pièces
       principales. Son ingénieur du son — compositeur, multi-instrumentiste et arrangeur —
      apporte sa touche musicale.`,
      `Un escalier fait office de chambre d’écho à l’ancienne, et juste à côté de la cabine de son,
       le jardin à l’anglaise permet de souffler, boire, manger ou rigoler… Ici, rires et bonne
       humeur sont au rendez-vous. Un lieu paisible, rassurant… et totalement vivant, qu’on
       quitte parfois à contrecœur.`,
    ],
    buttons: {
      equipment: "Équipement Studio",
      slideshow: "Diaporama",
      back: "Retour au studio",
    },
  },
  en: {
    title: "The studio",
    switchLang: "Cliquez ici pour la version française",
    paragraph: [
      `Ali Baba’s Cave!
      Instruments, mics, amps… and above all, good vibes!`,
      `A bright, welcoming, and adaptable studio where anything can happen: a large control
      room, a cozy space for drums, vocals, or instruments… and the whole house can also
      serve as isolated booths for amps while the band stays together in the main rooms. Its
      sound engineer — a composer, multi-instrumentalist, and arranger — adds his musical
      touch.`,
      `A staircase doubles as an old-style echo chamber, and just next to the sound booth, the
      English garden provides a place to relax, eat, drink, or have a laugh… Laughter and good
      humor are always part of the day here. A peaceful, reassuring, and fully alive space, that’s
      never easy to leave.`,
    ],
    buttons: {
      equipment: "Studio Equipment",
      slideshow: "Slideshow",
      back: "Back to studio",
    },
  },
};

export default studioTexts;
